import React, { useContext, useEffect, useState } from "react"
import AppContext from "../../shared/AppContext"
import { Redirect } from "react-router"
import gql from "graphql-tag"
import { Query } from "react-apollo"
import UpsellModal from "./components/UpsellModal"
import Card from "./components/Card"

import "./aiProductSeries.scss"

const AI_ALL_PRODUCT_SERIES = gql`
  query {
    getAllAiProductSeries {
      slug
      id
      name
      description
      roles
      interactiveReportFile {
        fileName
        name
        slug
      }
      mp4File {
        fileName
        name
        slug
      }
      reportFile {
        fileName
        name
        slug
      }
      dataFile {
        fileName
        name
        slug
      }
      pdfFile {
        fileName
        name
        slug
      }
      pdfFiles {
        fileName
        name
        slug
      }
    }
  }
`

const AiProductSeries = (props) => {
  const { isUserAuthenticated, roles } = props.viewer
  const { trackEvent } = useContext(AppContext)
  const [isUpsellModalOpen, setIsUpsellModalOpen] = useState(false)
  const [selectedBundleTitle, setSelectedBundleTitle] = useState(false)

  useEffect(() => {
    trackEvent("AI Product Series Page")
  }, [])

  if (!isUserAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: "/ai-product-series", search: props.location.search },
        }}
      />
    )
  }

  const accessRoles = [
    "AiProductSeries",
    "ETR Master Admin",
    "ETR Research Admin",
    "ETR Sales Admin",
  ]

  const hasRole = accessRoles.some((role) => roles.includes(role))

  return (
    <>
      <div className="ai-product-series-bundles-container">
        <div className="ai-product-series-bundles-list-container">
          <Query query={AI_ALL_PRODUCT_SERIES} fetchPolicy="network-only">
            {({ data, error, loading }) => {
              if (loading) {
                return <div>Loading...</div>
              }

              if (error || !data || !data.getAllAiProductSeries) {
                return <div>An error occurred while getting bundles.</div>
              }

              if (!data.getAllAiProductSeries.length) {
                return <div>No AI Product series found.</div>
              }

              return data.getAllAiProductSeries.map((series, i) => {
                return (
                  <Card
                    key={i}
                    series={series}
                    hasAccess={hasRole}
                    setIsUpsellModalOpen={(val) => setIsUpsellModalOpen(val)}
                    setSelectedBundleTitle={(title) =>
                      setSelectedBundleTitle(title)
                    }
                    {...props}
                  />
                )
              })
            }}
          </Query>
        </div>
      </div>
      <UpsellModal
        isOpen={isUpsellModalOpen}
        title={selectedBundleTitle}
        setIsUpsellModalOpen={setIsUpsellModalOpen}
      />
    </>
  )
}

export default AiProductSeries
